import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import './assets/css/iconfont.css'
import request from './request'
import reqCenter from '@/http/userCenter'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import {set, get } from '@/utils/localStorage'
import '@/icons/index.js'
import * as filters from "./utils/filter.js";
import '@/utils/permission';
import '@/assets/font/iconfont.css';

import 'lib-flexible/flexible.js'
Vue.use(ElementUI);
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
Vue.prototype.$layer = layer(Vue);
import { Mymessage, diaMessage } from '@/utils/common';
import TsaSignName from '@/plugins/realName/signName.js';
Vue.use(TsaSignName);

Vue.prototype.$msg = Mymessage;
Vue.prototype.$diamsg = diaMessage;
Vue.config.productionTip = false;
Vue.prototype.$request = request;
Vue.prototype.$reqCenter = reqCenter;
Vue.prototype.$setlocalStorage = set;
Vue.prototype.$getlocalStorage = get;
import './style/common.less'

//埋点注入
import TsaWebTrace from 'tsa-web-trace'
Vue.prototype.$TsaWebTrace = new TsaWebTrace({
  environment: process.env.VUE_APP_CURRENTMODE, //process.env.VUE_APP_CURRENTMODE
  appId: 19457,
})


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')